enum RouteEnum {
  Home = '/home',
  Episodes = '/episodes',
  About = '/about',
  Branch = '/branchies',
  News = '/news-events',
  Beneficiary = '/beneficiaries',
  Mytransfer = '/transcation',
  More = '/more',
  Calculator = '/calculator',
  Login = '/',
  Mpin = '/mpin',
  Register = '/register',
  VerifyOtp = '/verify-otp',
  ForgotPass = '/forgot-password',
  ForgotPin = '/forgot-pin',
  SetCredentials = '/set-credentials',
  ResetPass = '/reset-password',
  ResetPin = '/reset-pin',
  AddCustomer = '/add-customer',
  Rates = '/rates',
  Contact = '/contact',
  Profile = '/myprofile',
  Transfer = '/transfer',
  TranscationView = '/transcation-view',
  TermCondition = '/term-and-condition',
  ChangePassword = '/change-password',
  notfound = '/notfound',
}

export default RouteEnum;
